<div class="lds-ellipsis">
  <app-dot [color]="'supporting-13-green'" class="dot"></app-dot>
  <app-dot [color]="'supporting-13-green'" class="dot"></app-dot>
  <app-dot [color]="'supporting-13-green'" class="dot"></app-dot>
  <app-dot [color]="'supporting-13-green'" class="dot"></app-dot>
</div>
